//@flow

import {IconButton, makeStyles} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import {POPUP_BANNER_LAYOUTS} from '../PopupBannerForm/constants';

import type {PopupBanner} from '../../../../../../entities';
import {getImageUrl} from '../../../../../../utils/image_provider';

type Props = {
  banner: PopupBanner,
};

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    gap: '1rem',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '340px',
  },
  bannerImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
  },
  containerVertical: {
    aspectRatio: 75 / 106,
  },
  containerCenter: {
    aspectRatio: 22 / 25,
  },
  content: {
    left: 0,
    bottom: 0,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    position: 'absolute',
    zIndex: 2,
    gap: '.5rem',
    padding: '1rem',
  },
  contentVertical: {
    width: '100%',
    height: '45%',
    background: 'white',
  },
  contentCenter: {
    width: '100%',
    height: '100%',
    background: 'transparent',
    padding: '1.5rem',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    margin: 0,
    color: 'inherit',
    lineHeight: '1.1',
  },
  subTitle: {
    fontSize: '.85rem',
    margin: 0,
    fontWeight: 400,
    color: 'inherit',
  },
  button: {
    margin: '0',
    padding: '.75rem 2rem',
    backgroundColor: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '80px',
    fontSize: '.85rem',
    fontWeight: '600',
    width: 'max-content',
    cursor: 'pointer',
  },
  closePopupButton: {
    position: 'absolute',
    top: '.5rem',
    right: '.5rem',
    color: '#fff',
    padding: '.5rem',
    backgroundColor: 'rgba(0,0,0,.25)',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,.5)',
    },
  },
}));

export default function PopupPreview({banner}: Props) {
  const classes = useStyles();

  const bannerTextColor = banner.textColor;
  const buttonBgColor = banner.buttonBackgroundColor;
  const buttonTextColor = banner.buttonTextColor;
  const bannerTitle = banner.title;
  const bannerSubTitle = banner.subtitle;
  const layout = banner.popUpPositionType;

  const buttonText = banner.buttonText;
  const bannerBgColor = banner.backgroundColor;

  const contentStyles = {
    color: bannerTextColor,
  };

  const containerClasses = `${classes.container} ${
    layout === POPUP_BANNER_LAYOUTS.BELOW
      ? classes.containerVertical
      : classes.containerCenter
  }`;

  const contentClasses = `${classes.content} ${
    layout === POPUP_BANNER_LAYOUTS.BELOW
      ? classes.contentVertical
      : classes.contentCenter
  }`;

  const buttonStyles = {
    backgroundColor: buttonBgColor,
    color: buttonTextColor,
  };

  const containerStyles = {
    background: bannerBgColor,
  };

  const imageSrc = banner.imageId && getImageUrl(banner.imageId);

  return (
    <div className={containerClasses} style={containerStyles}>
      {imageSrc && (
        <img
          className={classes.bannerImage}
          src={imageSrc}
          alt={bannerSubTitle}
        />
      )}
      <IconButton className={classes.closePopupButton}>
        <Close fontSize="small" />
      </IconButton>
      <div className={contentClasses} style={contentStyles}>
        <h3 className={classes.title}>{bannerTitle}</h3>
        <h4 className={classes.subTitle}>{bannerSubTitle}</h4>
        {buttonText && (
          <button className={classes.button} style={buttonStyles}>
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
}
